import { fromJS } from 'immutable';

import {
  REQUEST_TOTAL_APPROVED,
  REQUEST_TOTAL_APPROVED_SUCCESS,
  REQUEST_TOTAL_APPROVED_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: { loading: false, error: false },
});

export function totalApprovedRequest() {
  return {
    type: REQUEST_TOTAL_APPROVED,
  };
}

export function totalApprovedSuccess(response) {
  return {
    type: REQUEST_TOTAL_APPROVED_SUCCESS,
    response,
  };
}

export function totalApprovedFailure(error) {
  return {
    type: REQUEST_TOTAL_APPROVED_FAILURE,
    error,
  };
}

export default function totalApprovedReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_TOTAL_APPROVED:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_TOTAL_APPROVED_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_TOTAL_APPROVED_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );
    default:
      return state;
  }
}
